window.addEventListener('load', (event) => {

  var rings = []
  var stones = []





  rings.push($('<span class="reel-pic"><img data-src="  //purediamond.ca/cdn/shop/t/12/assets/ring1.jpg?v=136066873298833113031763763179 " class="lazyload"/></span>'))
    stones.push($('<span class="reel-pic"><img data-src="  //purediamond.ca/cdn/shop/t/12/assets/stone1.jpg?v=5345071448005595881763763178 " class="lazyload"/></span>'))

    rings.push($('<span class="reel-pic"><img data-src="  //purediamond.ca/cdn/shop/t/12/assets/ring2.jpg?v=159082866952417201201763763179 " class="lazyload"/></span>'))
    stones.push($('<span class="reel-pic"><img data-src="  //purediamond.ca/cdn/shop/t/12/assets/stone2.jpg?v=78948031691869405561763763178 " class="lazyload"/></span>'))

    rings.push($('<span class="reel-pic"><img data-src="  //purediamond.ca/cdn/shop/t/12/assets/ring3.jpg?v=56088345803144624791763763179 " class="lazyload"/></span>'))
    stones.push($('<span class="reel-pic"><img data-src="  //purediamond.ca/cdn/shop/t/12/assets/stone3.jpg?v=18417838603512705211763763178 " class="lazyload"/></span>'))

    rings.push($('<span class="reel-pic"><img data-src="  //purediamond.ca/cdn/shop/t/12/assets/ring4.jpg?v=56695915967265057821763763179 " class="lazyload"/></span>'))
    stones.push($('<span class="reel-pic"><img data-src="  //purediamond.ca/cdn/shop/t/12/assets/stone4.jpg?v=110375523143850129101763763179 " class="lazyload"/></span>'))

    rings.push($('<span class="reel-pic"><img data-src="  //purediamond.ca/cdn/shop/t/12/assets/ring5.jpg?v=164538655733120295121763763180 " class="lazyload"/></span>'))
    stones.push($('<span class="reel-pic"><img data-src="  //purediamond.ca/cdn/shop/t/12/assets/stone5.jpg?v=157277682494304124921763763179 " class="lazyload"/></span>'))

    ;

    $(stones[2]).addClass('active');
    $(rings[4]).addClass('active');

    $('#home-reel-box').append($('<div class="left-box">').append(stones));
    $('#home-reel-box').append($('<div class="right-box">').append(rings));




// Subnavs
    $('.drawer__meganav-toggle')
      .on('click', function(evt) {
        var expanded = $(this).attr('aria-expanded') === 'true';
        if ($(this).is('a') && (expanded || evt.ctrlKey || evt.metaKey || evt.shiftKey || evt.altKey)) return;
        evt.preventDefault();
        var controls = $(this).attr('aria-controls');
        $('.drawer__meganav-toggle').attr('aria-expanded', 'false');
        $('.meganav--drawer').stop(true, true).slideUp(200);
        $(this).attr('aria-expanded', JSON.stringify(! expanded));
        if (! expanded) {
          $('#' + controls).stop(true, true).slideDown(200);
        }
      })

      function closeDesktopNavItem($item) {
        var $dropdown = $item.find('.site-nav__dropdown').first();
        if (! $dropdown.length) return;

        $item.removeClass('site-nav__item--open');
        $item.find('.site-nav__link-toggle').attr('aria-expanded', 'false');
        $dropdown.stop(true, true).fadeOut(140);
      }

      function openDesktopNavItem($item) {
        var $dropdown = $item.find('.site-nav__dropdown').first();
        if (! $dropdown.length) return;

        $('.site-nav__item').not($item).each(function() {
          closeDesktopNavItem($(this));
        });

        $item.addClass('site-nav__item--open');
        $item.find('.site-nav__link-toggle').attr('aria-expanded', 'true');
        $dropdown.stop(true, true).fadeIn(180);
      }

      var navPointerType = 'mouse';
      var touchNavWasOpen = false;

      $(document).on('pointerdown', function(evt) {
        navPointerType = evt.originalEvent.pointerType;
        var $item = $(evt.target).closest('.site-nav__item');
        // Capture before touch-generated focus/hover can open the dropdown.
        touchNavWasOpen = $item.hasClass('site-nav__item--open');
        if (! $item.length) {
          $('.site-nav__item').each(function() {
            closeDesktopNavItem($(this));
          });
        }
      }).on('keydown', function() {
        navPointerType = 'keyboard';
      });

      $('.site-nav__item > .site-nav__link-toggle').on('click', function(evt) {
        if (navPointerType !== 'touch' || evt.detail === 0 || evt.ctrlKey || evt.metaKey || evt.shiftKey || evt.altKey) return;
        if (touchNavWasOpen) return;
        evt.preventDefault();
        openDesktopNavItem($(this).closest('.site-nav__item'));
      });

      $('.site-nav__item')
      .on('pointerenter', function(evt) {
        if (evt.originalEvent.pointerType === 'touch') return;
        openDesktopNavItem($(this));
      })
      .on('pointerleave', function(evt) {
        if (evt.originalEvent.pointerType === 'touch') return;
        closeDesktopNavItem($(this));
      })
      .on('focusin', function() {
        if (navPointerType === 'touch') return;
        openDesktopNavItem($(this));
      })
      .on('focusout', function(evt) {
        if ($(this).has(evt.relatedTarget).length) return;
        closeDesktopNavItem($(this));
      });

      $(document).on('keyup', function(evt) {
        if (evt.key !== 'Escape') return;
        $('.site-nav__item').each(function() {
          closeDesktopNavItem($(this));
        });
      });


  // Homepage Sale slider


  /*
   $('.home-sale-slider').slick({
   centerMode: true,
   centerPadding: '60px',
   slidesToShow: 5,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 3000,
   arrows: false,
   responsive: [
   {
   breakpoint: 768,
   settings: {
   arrows: false,
   centerMode: true,
   centerPadding: '40px',
   slidesToShow: 3
   }
   },
   {
   breakpoint: 480,
   settings: {
   arrows: false,
   centerMode: true,
   centerPadding: '40px',
   slidesToShow: 1
   }
   }
   ]
   })
*/


  // The discovery controller owns its filters and pagination.
  if (!document.querySelector('[data-pd-discovery]')) {
  // Collection Filters

      function normalizeFilterTag(value) {
        return String(value || '')
          .toLowerCase()
          .trim()
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-');
      }

      var normalizedThemeTags = (theme.tags || []).map(normalizeFilterTag);


      Object
      .entries(theme.filters)
      .map(function(item, key) {

        var filter = $('<div class="collection-filter">');
        var select = $('<select class="coll-filter-select">');
        var selectedValue = '';

        filter.append($('<span>').html(item[0]));
        select.append($('<option value="">All</option>'));
        select.append(item[1].map(function(tag) {
          if (!selectedValue && normalizedThemeTags.indexOf(normalizeFilterTag(tag[1])) > -1) {
            selectedValue = tag[1];
          }

          return $('<option>').attr('value', tag[1]).html(tag[0]);
        }));

        if (selectedValue) {
          select.val(selectedValue);
        }

        filter.append(select);

        $('.filters-grid-container').append(filter);

      })


// $.get({
// url: '/products.json',
// success: function (data) {

// }
// })


    // Collection Manager for Filtering and Lazy Loading
    theme.CollectionManager = (function() {
      var selectors = {
        grid: '.products-grid',
        productWrapper: '.product-grid-item-wrapper',
        loadMoreBtn: '.load-more-btn',
        spinner: '.load-more-spinner',
        pagination: '#AjaxinatePagination',
        count: '.collection-count',
        filterSelect: '.coll-filter-select',
        emptyState: '.collection-empty-state-wrapper'
      };

      var state = {
        priceMin: null,
        priceMax: null,
        isLoading: false,
        hasMore: $(selectors.loadMoreBtn).length > 0,
        nextUrl: $(selectors.loadMoreBtn).attr('href')
      };

      function init() {
        // Check for initial price filter in URL hash
        if (window.location.hash && window.location.hash.startsWith('#price-range:')) {
          var priceFilter = window.location.hash.substring(1);
          setPriceRange(priceFilter);
          
          // Sync dropdowns
          $(selectors.filterSelect).each(function() {
            var options = $(this).find('option');
            options.each(function() {
              if ($(this).val() === priceFilter) {
                $(this).parent().val(priceFilter);
              }
            });
          });
        } else {
          updateCount();
        }

        bindEvents();
      }

      function bindEvents() {
        // Infinite Scroll
        $(window).on('scroll', function() {
          if (!state.hasMore || state.isLoading) return;
          // Load earlier (1500px buffer)
          if ($(window).scrollTop() + $(window).height() > $(document).height() - 1500) {
            loadMore(false);
          }
        });

        // Load More Button
        $(document).on('click', selectors.loadMoreBtn, function(e) {
          e.preventDefault();
          loadMore(false);
        });
      }

      function setPriceRange(rangeStr) {
        if (!rangeStr) {
          state.priceMin = null;
          state.priceMax = null;
        } else {
          rangeStr = rangeStr.replace('price-range:', '');
          if (rangeStr.endsWith('-plus')) {
            state.priceMin = parseInt(rangeStr.replace('-plus', '')) * 100;
            state.priceMax = Infinity;
          } else {
            var parts = rangeStr.split('-');
            state.priceMin = parseInt(parts[0]) * 100;
            state.priceMax = parseInt(parts[1]) * 100;
          }
        }
        filterGrid();
      }

      function filterGrid() {
        var $products = $(selectors.productWrapper);
        var visibleCount = 0;

        $products.each(function() {
          var $el = $(this);
          var price = parseInt($el.attr('data-product-price'));
          var isVisible = true;

          if (state.priceMin !== null) {
            if (price < state.priceMin || price > state.priceMax) {
              isVisible = false;
            }
          }

          if (isVisible) {
            $el.show().addClass('visible-by-price');
            visibleCount++;
          } else {
            $el.hide().removeClass('visible-by-price');
          }
        });

        updateCount();
        handleEmptyState(visibleCount);

        // Auto-load if few items are visible and we have more pages
        if (visibleCount < 4 && state.hasMore && !state.isLoading) {
          loadMore(true);
        }
      }

      function updateCount() {
        var visibleCount = $(selectors.productWrapper + ':visible').length;
        var totalCount = parseInt($(selectors.grid).attr('data-products-count')) || 0;
        var text = '';

        if (state.priceMin !== null) {
          text = visibleCount + ' Products';
        } else {
          text = totalCount + ' Products';
        }
        $(selectors.count).text(text);
      }

      function handleEmptyState(visibleCount) {
        if (visibleCount === 0 && !state.hasMore) {
          if ($(selectors.emptyState).length === 0) {
            var collectionUrl = theme.collectionHandle ? '/collections/' + theme.collectionHandle : window.location.pathname.split('#')[0];
            $(selectors.grid).after(
              '<div class="collection-empty-state-wrapper">' +
                '<div class="collection-empty-state">' +
                  '<p class="collection-empty-state__title">No products found in this price range</p>' +
                  '<p class="collection-empty-state__text">Try adjusting your filters, or start over to browse everything in this collection.</p>' +
                  '<a href="' + collectionUrl + '" class="btn btn--secondary collection-empty-state__reset">Reset filters</a>' +
                '</div>' +
              '</div>'
            );
          }
        } else {
          $(selectors.emptyState).remove();
        }
      }

      function loadMore(isAutoLoad) {
        if (state.isLoading || !state.hasMore) return;

        state.isLoading = true;
        $(selectors.loadMoreBtn).hide();
        $(selectors.spinner).show();

        $.ajax({
          url: state.nextUrl,
          type: 'GET',
          dataType: 'html',
          success: function(data) {
            var $data = $(data);
            var $newProducts = $data.find(selectors.productWrapper);
            var $nextBtn = $data.find(selectors.pagination + ' ' + selectors.loadMoreBtn);

            if ($newProducts.length) {
              // Silent Loading: Filter items BEFORE appending
              if (state.priceMin !== null) {
                $newProducts.each(function() {
                  var price = parseInt($(this).attr('data-product-price'));
                  if (price < state.priceMin || price > state.priceMax) {
                    $(this).hide().removeClass('visible-by-price');
                  } else {
                    $(this).addClass('visible-by-price');
                  }
                });
              }

              // Apply Staggered Animation
              $newProducts.each(function(index) {
                $(this).addClass('fade-up').css('animation-delay', (index * 50) + 'ms');
              });

              $(selectors.grid).append($newProducts);
              updateCount();
              
              // Recalculate visible count after append
              var visibleCount = $(selectors.productWrapper + ':visible').length;
              handleEmptyState(visibleCount);
            }

            if ($nextBtn.length) {
              state.nextUrl = $nextBtn.attr('href');
              state.hasMore = true;
              $(selectors.loadMoreBtn).attr('href', state.nextUrl).show();
            } else {
              state.hasMore = false;
              $(selectors.pagination).hide();
              // Final check for empty state if we reached end
              var finalVisible = $(selectors.productWrapper + ':visible').length;
              handleEmptyState(finalVisible);
            }
          },
          complete: function() {
            state.isLoading = false;
            $(selectors.spinner).hide();

            // Recursive check for auto-load
            if (isAutoLoad && state.hasMore) {
               var visibleCount = $(selectors.productWrapper + ':visible').length;
               if (visibleCount < 4) {
                 loadMore(true);
               }
            }
          }
        });
      }

      // Public API
      return {
        init: init,
        setPriceRange: setPriceRange
      };
    })();

    // Initialize Manager
    theme.CollectionManager.init();

    function filterSelect() {
      // Close mobile drawer if open
      $('.collection-filters').removeClass('active');
      $('body').css('overflow', '');

      var priceFilter = null;
      var tagFilters = [];
      
      $('.coll-filter-select').each(function() {
        var value = $(this).val();
        if (value) {
          if (value.startsWith('price-range:')) {
            priceFilter = value;
          } else {
            tagFilters.push(value);
          }
        }
      });

      if (tagFilters.length > 0) {
        var query = tagFilters.join('+');
        var targetUrl = '/collections/' + theme.collectionHandle + '/' + query;
        if (priceFilter) {
          targetUrl += '#' + priceFilter;
        }
        window.location.href = targetUrl;
      } 
      else if (priceFilter) {
        // Use Manager to set price
        window.location.hash = priceFilter;
        theme.CollectionManager.setPriceRange(priceFilter);
        
        // Scroll to top of product grid on mobile to show filtered results
        // Scroll back to products on mobile only; desktop is already in view
        if (window.innerWidth < 769) {
          var $grid = $('.products-grid');
          if ($grid.length) {
            $('html, body').animate(
              { scrollTop: $grid.offset().top - 100 },
              0
            );
          }
        }
      } 
      else {
        if (theme.collectionHandle) {
          window.location.href = '/collections/' + theme.collectionHandle;
        }
      }
    }


  }

    $('[data-fancybox="gallery"], [data-fancybox]').fancybox({animationEffect: "fade", transitionDuration: 200});


// Material selector
    $('.material-option').on('click', function() {
      var $group = $(this).closest('.material-options-box');
      $group.find('.material-option').removeClass('option-selected').attr('aria-pressed', 'false');
      $(this).addClass('option-selected').attr('aria-pressed', 'true');
      $group.find('input.material-selected-value').val($(this).attr('data-value')).change();
    });


// Google reviews
    if ($("#google-reviews-list")[0]) {
      fetch("\/\/purediamond.ca\/cdn\/shop\/t\/12\/assets\/place-details.json?v=175223669333902158281763763178").then(response => response.json()).then(data => {
          if (data && data.result && data.result.reviews) {
            const reviews = data.result.reviews;
            const reviewsContainer = $("#google-reviews-list");
            let reviewsHTML = "";

  // Filter reviews by minRating (e.g. 4) and maxRows (e.g. 6)
  // These values are based on the original googlePlaces plugin options
            const minRating = 4;
            const maxRows = 6;
            let displayedReviews = 0;

            for (let i = 0; i < reviews.length && displayedReviews<maxRows; i++) {
        const review = reviews[i];
        if (review.rating >= minRating) {
              reviewsHTML += `
              <div class="review-item-long">
                <div class="review-meta">
                  ${
                review.profile_photo_url
                  ? `<img class='review-picture' src='${
                  review.profile_photo_url
                }'>` : ''
              }
                  <span class="review-author">${
                review.author_name
              }</span>
                  <span class="review-date">${
                review.relative_time_description
              }</span>
                </div>
                <div class="review-stars">
                  <ul>
                    ${
                Array(review.rating).fill('<li><i class="star"></i></li>').join('')
              }
                    ${
                Array(5 - review.rating).fill('<li><i class="star inactive"></i></li>').join('')
              }
                  </ul>
                </div>
                <div class="review-text">${
                review.text
              }</div>
              </div>
            `;
              displayedReviews++;
            }
          }
          reviewsContainer.html(reviewsHTML);

  // Initialize Slick Carousel
          reviewsContainer.slick({
            centerMode: true,
            centerPadding: '0',
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 12000,
            arrows: true,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  arrows: true,
                  centerMode: true,
                  centerPadding: '0',
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });
        }

  // Update review count
          if(data && data.result && data.result.user_ratings_total) {
          $('.google-reviews-count').html(data.result.user_ratings_total);
        }
      }
    ).catch(error => console.error('Error fetching Google reviews cache:', error));
  }

  $('#currency_selector select').val(Shopify.country);

  $('#currency_selector select').on('change', function() {
    $.post("/localization", $("#currency_selector").serialize()).done(function() {
      location.reload();
    })

  });


  if(window.prodID) {
    $.get("https://llateedi.sirv.com/products/" + window.prodID + "/" + window.prodID + ".spin").done(function() {
      var el = '<div class="product-single__thumbnail-item"><a data-type="iframe" href="https://llateedi.sirv.com/products/' + window.prodID + '/' + window.prodID + '.spin" class="thumb-360 product-single__thumbnail" data-fancybox="gallery"><img src="//purediamond.ca/cdn/shop/t/12/assets/icon-360.svg?v=39027500819357148921763763180 "/></a></div>';
      $(".product-single__thumbnails").prepend(el);
    });
  }

  $('.affirm-modal-link').on('click', function(event) {
    var href = $(this).attr('href');
    var hasExternalUrl = href && href !== '#' && href.indexOf('javascript:') !== 0;

    if (hasExternalUrl && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.which > 1)) {
      return;
    }

    event.preventDefault();
    affirm.ui.openModal();
  })

// Mobile Filter Toggle
    $('.mobile-filter-trigger').on('click', function() {
    $('.collection-filters').addClass('active');
    $('body').css('overflow', 'hidden');
  });

  $('.mobile-filter-close, .mobile-filter-backdrop').on('click', function() {
    $('.collection-filters').removeClass('active');
    $('body').css('overflow', '');
  });

  $('.mobile-filter-done').on('click', function() {
    filterSelect();
  });

  // Immediate filtering on desktop
  $(document).on('change', '.coll-filter-select', function() {
    if (window.innerWidth > 768) {
      filterSelect();
    }
  });

  function initStickyProductInfo() {
    var infoContainer = document.querySelector('.product-single__info-container');
    if (!infoContainer) return;

    function updateSticky() {
      if (window.innerWidth < 750) {
        infoContainer.style.top = 'auto';
        return;
      }

      var header = document.querySelector('.site-header');
      var headerHeight = header ? header.offsetHeight : 0;
      var viewportHeight = window.innerHeight;
      var elementHeight = infoContainer.offsetHeight;
      var offset = 20; // Padding

      if (elementHeight < (viewportHeight - headerHeight)) {
        // Fits in viewport: stick to top
        infoContainer.style.top = (headerHeight + offset) + 'px';
      } else {
        // Taller than viewport: stick to bottom (negative top)
        // Top should be such that bottom of element aligns with bottom of viewport
        // top = viewportHeight - elementHeight - offset
        infoContainer.style.top = (viewportHeight - elementHeight - offset) + 'px';
      }
    }

    window.addEventListener('resize', updateSticky);
    // Initial call
    updateSticky();
    
    // Update on mutation (e.g. reviews loading)
    var observer = new MutationObserver(updateSticky);
    observer.observe(infoContainer, { childList: true, subtree: true, attributes: true });
    
    // Also update after a short delay to ensure images/fonts are loaded
    setTimeout(updateSticky, 1000);
    setTimeout(updateSticky, 3000);
  }

  initStickyProductInfo();

  var homepageHeroVideoSources = [
    "\/\/purediamond.ca\/cdn\/shop\/t\/12\/assets\/homepage-hero-video-1.mp4?v=104146107864142586341784787897",
    "\/\/purediamond.ca\/cdn\/shop\/t\/12\/assets\/homepage-hero-video-2.mp4?v=136094636232557513111784787898",
    "\/\/purediamond.ca\/cdn\/shop\/t\/12\/assets\/homepage-hero-video-3.mp4?v=81543406075665384411784787900",
    "\/\/purediamond.ca\/cdn\/shop\/t\/12\/assets\/homepage-hero-video-4.mp4?v=30592445747354180931784787901"
  ];

  function initHomepageVideoHero(hero) {
    if (!hero || hero.dataset.homepageVideoHeroReady === 'true') return;

    var card = hero.querySelector('[data-homepage-video-card]');
    var videos = [
      hero.querySelector('[data-homepage-video-face="front"]'),
      hero.querySelector('[data-homepage-video-face="back"]')
    ];

    if (!card || !videos[0] || !videos[1]) return;

    hero.dataset.homepageVideoHeroReady = 'true';

    var activeFace = 0;
    var activeVideoIndex = 0;
    var cardTurn = 0;
    var isFlipping = false;
    var flipTimer;
    var prefersReducedMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function prepareVideo(video, videoIndex, preloadValue) {
      if (video.dataset.homepageVideoIndex === String(videoIndex)) return;

      video.pause();
      video.classList.remove('is-ready');
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.preload = preloadValue;
      video.src = homepageHeroVideoSources[videoIndex];
      video.dataset.homepageVideoIndex = String(videoIndex);
      video.load();
    }

    function playVideo(video) {
      var playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function() {
          hero.classList.add('homepage-hero-2026--playback-paused');
        });
      }
    }

    function finishFlip(nextFace, nextVideoIndex) {
      if (!isFlipping) return;

      window.clearTimeout(flipTimer);
      videos[activeFace].pause();
      activeFace = nextFace;
      activeVideoIndex = nextVideoIndex;
      isFlipping = false;
      card.classList.remove('is-flipping');

      var upcomingVideoIndex = (activeVideoIndex + 1) % homepageHeroVideoSources.length;
      prepareVideo(videos[1 - activeFace], upcomingVideoIndex, 'metadata');
    }

    function advanceVideo() {
      if (isFlipping || document.hidden) return;

      var nextFace = 1 - activeFace;
      var nextVideoIndex = (activeVideoIndex + 1) % homepageHeroVideoSources.length;
      var nextVideo = videos[nextFace];

      prepareVideo(nextVideo, nextVideoIndex, 'auto');

      try {
        nextVideo.currentTime = 0;
      } catch (error) {
        // The video will start at zero once its metadata is ready.
      }

      isFlipping = true;
      card.classList.add('is-flipping');

      window.setTimeout(function() {
        playVideo(nextVideo);
      }, prefersReducedMotion ? 0 : 360);

      window.requestAnimationFrame(function() {
        cardTurn += 180;
        card.style.setProperty('--homepage-hero-card-turn', cardTurn + 'deg');
      });

      flipTimer = window.setTimeout(function() {
        finishFlip(nextFace, nextVideoIndex);
      }, prefersReducedMotion ? 50 : 1050);
    }

    card.addEventListener('transitionend', function(event) {
      if (event.target !== card || event.propertyName !== 'transform' || !isFlipping) return;

      finishFlip(1 - activeFace, (activeVideoIndex + 1) % homepageHeroVideoSources.length);
    });

    videos.forEach(function(video) {
      video.addEventListener('loadeddata', function() {
        video.classList.add('is-ready');
      });

      video.addEventListener('ended', function() {
        if (video === videos[activeFace]) {
          advanceVideo();
        }
      });
    });

    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        videos[activeFace].pause();
        return;
      }

      playVideo(videos[activeFace]);
    });

    prepareVideo(videos[0], 0, 'auto');
    prepareVideo(videos[1], 1, 'metadata');
    playVideo(videos[0]);
  }

  document.querySelectorAll('[data-homepage-video-hero]').forEach(initHomepageVideoHero);

  document.addEventListener('shopify:section:load', function(event) {
    var hero = event.target.querySelector('[data-homepage-video-hero]');

    if (hero) {
      initHomepageVideoHero(hero);
    }
  });

})
